import {Reducer} from "redux";
import {LocatorFilterActions, LocatorResultsActionType} from "../../actions/postshop-locator/locatorFilterActions";

export const initialState: string = "send_a_parcel_in_nz";

const locatorFilterReducer: Reducer<string> = (state: string = initialState, action) => {
    switch ((action as LocatorFilterActions).type) {
        case LocatorResultsActionType.SET_FILTER:
            return action.payload.selectedFilter;
        default:
            return state;
    }
};

export default locatorFilterReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/postshop-locator/locatorFilterReducer.tsx